<template>
  <div :class="{ disabled }" class="landing-button">{{ title }}</div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      required: true,
    },
  },
  setup() {
    
  },
}
</script>
<style lang="scss" scoped>
  .landing-button {
    font-family: 'YoungSerif-Regular';
    min-width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: $black;
    color: $textWhite;
    font-size: 16px;
    border-radius: $controlRadius;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    letter-spacing: 0.5px;
    
    // Create a shine effect on hover
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.1),
        transparent
      );
      transition: left 0.7s ease;
    }
    
    &:hover {
      opacity: 0.95;
      transform: translateY(-2px);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
      
      &:before {
        left: 100%;
      }
    }

    &.disabled {
      opacity: .2;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;

      &:hover {
        opacity: .2;
        transform: none;
        box-shadow: none;
      }
    }
  }

  @media (max-width: $tabletSize) {
    .landing-button {
      height: 46px;
      line-height: 46px;
      min-width: 180px;
      font-size: 15px;
    }
  }
</style>